const GOOGLE_OPTIMIZE_EXPERIMENT_ID_SEARCH_BAR_ON_HOME =
    'TotPGiyUR36kVVhONpqVdg';

const NOOP = () => null;

export const enrollInSearchBarOnHomeOptimizeExperiment = (
    setSearchBarOnHomeOptimizeEnrollmentStatus = NOOP,
) => {
    if (window.gtag) {
        window.gtag('event', 'optimize.callback', {
            name: GOOGLE_OPTIMIZE_EXPERIMENT_ID_SEARCH_BAR_ON_HOME,
            callback: (value, name) => {
                if (name === GOOGLE_OPTIMIZE_EXPERIMENT_ID_SEARCH_BAR_ON_HOME) {
                    if (value == '0') {
                        setSearchBarOnHomeOptimizeEnrollmentStatus('A');
                    } else if (value == '1') {
                        setSearchBarOnHomeOptimizeEnrollmentStatus('B');
                    } else if (value == '2') {
                        setSearchBarOnHomeOptimizeEnrollmentStatus('C');
                    } else {
                        // just to be extra safe
                        setSearchBarOnHomeOptimizeEnrollmentStatus('A');
                    }
                } else {
                    // just to be extra safe
                    setSearchBarOnHomeOptimizeEnrollmentStatus('A');
                }
            },
        });
    } else {
        // If no Optimize is available we still want to set to A
        setSearchBarOnHomeOptimizeEnrollmentStatus('A');
    }
};

export const shouldOverrideExperimentVariantB = () => {
    if (typeof window === 'object' && window.location) {
        return window.location.href.endsWith('#b');
    }

    return false;
};

export const shouldOverrideExperimentVariantC = () => {
    if (typeof window === 'object' && window.location) {
        return window.location.href.endsWith('#c');
    }

    return false;
};
